module.exports = __webpack_public_path__ + "static/media/map.92d2ee3a.svg";